







import Vue, { PropType } from "vue";

export default Vue.extend({
  name: "Accordion",
  props: {
    numberOfDropdowns: {
      type: Number as PropType<number>,
      required: true,
    },
  },
  methods: {
    closeOpened(opened: number): void {
      this.$children.forEach((drop: any, index) => {
        if (index !== opened) {
          drop.close();
        }
      });
    },
  },
});
